module.exports = __webpack_public_path__ + "img/decorator-dots-magenta.9d2321c.svg";